export default __webpack_public_path__ + "static/media/2_0036.7510e791.webp";